import { render, staticRenderFns } from "./betconstruct-frame.vue?vue&type=template&id=64fd2bb0"
import script from "./betconstruct-frame.vue?vue&type=script&lang=js"
export * from "./betconstruct-frame.vue?vue&type=script&lang=js"
import style0 from "./betconstruct-frame.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/betconstruct/betconstruct-frame.vue
// module id = Cf7f
// module chunks = 0